import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Particle from "../Particle";
import pdf from "../../Assets/Resume/Varshini_Resume_Latest.pdf";

function ResumeNew() {
  return (
    <Container fluid className="resume-section">
      <Particle />
      <Row className="justify-content-center text-center mb-4">
        <Col md={10} lg={8}>
          <h1 className="project-heading">
            My <strong className="purple">Resume</strong>
          </h1>
          <p>Download or preview the most recent static resume below. Dynamic Resume built on real-evidence coming soon (CareerMojo v0.3 release, Feb 16th, 2026)</p>
          <Button variant="primary" href={pdf} target="_blank" rel="noreferrer">
            Download PDF
          </Button>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={10}>
          <div className="resume-preview">
            <iframe
              title="Varshini Balaji Resume"
              src={pdf}
              width="100%"
              height="900px"
              style={{ border: "none", borderRadius: "16px", boxShadow: "var(--shadow-soft)" }}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ResumeNew;
